import ZRemind from './ZRemind.vue'

export default ZRemind
